import { words } from 'globalState';
import { getAddressFromKey, signWithKey, getValidKeyPairs } from './keysAndSigning';
import { getAssetInfo } from './blockchain';
import { devLog, syncHttpRequest2 } from 'utils';


// 「カード登録申請」ボタン押下 HANDLE CLICK APPLY FOR CARD REGISTRATION
async function handleClickApplyForCardRegistration(state, dispatch, keyPairsInPoolAll, stateAssetInfo, clientParameters) {
  let addressMainActual;
  let signature;
  let request = {};
  let messages = {};
  let result;

  // state固定
  const stateFixed = {
    // addressMain: state.cardRegistration.addressMain,
    asset: state.cardRegistration.asset,
    name: state.cardRegistration.name,
    feature: state.cardRegistration.feature,
    attribute: state.cardRegistration.attribute,
    contact: state.cardRegistration.contact,
    mailAddress: state.cardRegistration.mailAddress,
    // imageMain: state.cardRegistration.imagesNew.main,
    signatureVersion: state.config.clientParameters.signatureVersion.applyForCardRegistration,
    // addressCheck: state.addressCheck,
  };

  // 必須項目チェック
  if (stateFixed.asset === undefined || stateFixed.asset === null || stateFixed.asset === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.assetMustBeFilled[state.language] });
    return;
  }

  if (stateFixed.name === undefined || stateFixed.name === null || stateFixed.name === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.nameMustBeFilled[state.language] });
    return;
  }

  if (stateFixed.feature === undefined || stateFixed.feature === null || stateFixed.feature === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.featureMustBeFilled[state.language] });
    return;
  }

  if (stateFixed.contact === undefined || stateFixed.contact === null || stateFixed.contact === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.contactMustBeFilled[state.language] });
    return;
  }

  // 文字数チェック
  if (stateFixed.name.length > 25) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.nameIsTooLong[state.language] });
    return;
  }

  if (stateFixed.feature.length > 70) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.featureIsTooLong[state.language] });
    return;
  }

  if (stateFixed.attribute !== undefined && stateFixed.attribute !== null && stateFixed.attribute !== '' && stateFixed.attribute.length > 20) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.attributeIsTooLong[state.language] });
    return;
  }

  const resultAssetInfo = await getAssetInfo({ dispatch, assets: [stateFixed.asset], assetInfos: stateAssetInfo, clientParameters });

  let assetsInfo;
  if (resultAssetInfo.status === 'fulfilled') {
    assetsInfo = resultAssetInfo.body;
  }
  else {
    throw new Error(resultAssetInfo.error);
  }

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: keyPairsInPoolAll });
  const keyPair = keyPairsInPool[assetsInfo[stateFixed.asset].owner]?.keyPair;

  // アドレスは入力させていないので、ノーチェックで署名する。
  const clientTime = Date.now();

  if (keyPair !== undefined && keyPair !== null) {
    let result;

    // keyPair = keyPairs[0];
    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressMainActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return result;
    }

    // 署名
    const message = `I apply for card registration of ${stateFixed.asset}. My main address is ${addressMainActual}. I am the owner of the card. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    devLog('message', message);

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else {
    result = await window.mpurse.getAddress()
    .then( (result) => {
      addressMainActual = result;

      // if (stateFixed.addressCheck === 'strict' || stateFixed.addressCheck === 'addressSecond') {
      //   if (addressMainActual !== stateFixed.addressMain) {
      //     dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
      //     return 'rejected';
      //   }
      //   else {
      //     return 'fulfilled';
      //   }
      // }
      // else { // off
      //   return 'fulfilled';
      // }

      return 'fulfilled';
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    const message = `I apply for card registration of ${stateFixed.asset}. My main address is ${addressMainActual}. I am the owner of the card. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    devLog('message', message);

    result = await window.mpurse.signMessage(message)
    .then( result => {
      signature = result;
      return 'fulfilled';
    })
    .catch( err => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }
  }

  const formData = new FormData();

  const requestJson = JSON.stringify({
    body: {
      addressMain: addressMainActual,
      addressMainActual: addressMainActual,
      asset: stateFixed.asset,
      name: stateFixed.name,
      feature: stateFixed.feature,
      attribute: stateFixed.attribute,
      contact: stateFixed.contact,
      mailAddress: stateFixed.mailAddress,
      clientTime : clientTime,
      signature : signature,
      signatureVersion : stateFixed.signatureVersion,
    }
  });

  formData.append('json', requestJson);

  // if (stateFixed.imageMain !== undefined && stateFixed.imageMain !== null) {
  //   formData.append('imageMain', stateFixed.imageMain, stateFixed.imageMain.name);
  // }

  request.body = formData;
  request.headers = {};
  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/apply_for_card_registration';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "out of service": words.outOfService[state.language],
    "signature by asset owner is required.": words.signatureByAssetOwnerIsRequired[state.language],
    "asset is required; not asset_longname.": words.assetIsRequiredNotAssetLongname[state.language],
    "No such token exists.": words.noSuchTokenExists[state.language],
    // "you are not delegated.": words.norIsTheSignatureDelegatedFromMainAddress[state.language],
    // "addressMainActual must be filled.": words.clearYourBrowserOrAppCache[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', addressMainActual],
      value: {'sessionId': response.body.sessionId.addressMain, 'expirationOfSession': response.body.expirationOfSession.addressMain} });

    // if (addressMainActual !== stateFixed.addressMain) {
    //   dispatch({ type: 'setStateMultiLayers', keys: ['session', addressMainActual],
    //     value: {'sessionId': response.body.sessionId.addressMainActual, 'expirationOfSession': response.body.expirationOfSession.addressMainActual} });
    // }

    // // cookie情報更新(アドレス情報)
    // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    // const cookiesNew = [
    //       {
    //         action: 'setUp',
    //         addressType: 'addressMain',
    //         description: `${userName}`,
    //         time: clientTime,
    //         address: stateFixed.addressMain
    //       },
    // ];

    // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);
  }
  else {
  }

  return response;
}

export { handleClickApplyForCardRegistration };
